import {
  useGetSubjectsByProfileIdQuery,
  useLazyGetSubjectsByProfileIdQuery,
  subjectApiSlice,
} from './lib/subjectsDataSlice';

const upsertSubjectsQueryData = subjectApiSlice.util.upsertQueryData;

export {
  subjectApiSlice,
  useGetSubjectsByProfileIdQuery,
  useLazyGetSubjectsByProfileIdQuery,
  upsertSubjectsQueryData,
};
